/**
 *  @file       UserOperations.js
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *              Portal client operations related to user/identity
 */

import { ErrorOperations } from '@/operations/ErrorOperations';
import { LoginOperations } from '@/features/auth';

export class UserOperations
{
  static async updateUserPreferences()
  {
    await window.dcp.utils.prefs.save('portal');
  }

  static getUserPreferences()
  {
    return window.dcp.utils.prefs.load('portal');
  }

  static async checkPassword(password)
  {
    const apiUrl = window.dcpConfig.oAuth.location.resolve(
      '/api/v1/users/checkPassword',
    );
    
    const res = await fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('oauth_token')}`,
      },
      body: JSON.stringify({ password }),
    })
    
    if (!res.ok)
    {
      ErrorOperations.displayError('Could not validate password.');
      return false;
    }
    
    const data = await res.json();
    return data.valid;
  }
}
